<template>
  <div class="form-group">
    <label v-if="label">{{ label }}</label>
    <select v-if="options" class="form-control form-control-custom"
      :class="[
        {[`rounded-${rounded}`]: rounded},
        {[`bg-${bg}`]: bg},
        {[`form-control-${size}`]: size},
        [bg === 'white'? 'bordered': '']
      ]"
      :style="[
        {padding:p}
      ]"
    >
      <option v-for="(option, index) in options" :key="index" :value="option.value">
        {{ option.text }}
      </option>
    </select>
    <i class="fas fa-caret-down"></i>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => []
    },
    bg: {
      type: String,
      default: 'gray'
    },
    size: String,
    p: {
      type: String,
      default: ''
    },
    rounded: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>